import { render, staticRenderFns } from "./treatmentOrder.html?vue&type=template&id=20df03d6&scoped=true&"
import script from "./treatmentOrder.js?vue&type=script&lang=js&"
export * from "./treatmentOrder.js?vue&type=script&lang=js&"
import style0 from "./treatmentOrder.scss?vue&type=style&index=0&id=20df03d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df03d6",
  null
  
)

export default component.exports